<template>
    <div>
        <button class="ml-2 btn btn-sm btn-default" v-on:click="modal.show()">WIP Reports</button>

        <div class="modal" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <form class="modal-content" method="get" :action="reportRoutes[currentReport]">
                    <div class="block block-rounded block-transparent mb-0">
                        <div class="block-header block-header-default">
                            <h3 class="block-title">Select Report Type</h3>
                            <div class="block-options">
                                <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-fw fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content">
                            <div class="mb-4 d-flex">
                                <div v-if="onlyWip === null" class="form-check">
                                    <input class="form-check-input" type="radio" :id="`wip-report-All`" name="wip-report" value="All" v-model="currentReport">
                                    <label class="form-check-label" :for="`wip-report-All`">All</label>
                                </div>
                                <template v-for="(type) in ['Stock', 'Fleet', 'Customer']">
                                    <div v-if="onlyWip === null || onlyWip === type" class="form-check">
                                        <input class="form-check-input" type="radio" :id="`wip-report-${type}`" name="wip-report" :value="type" v-model="currentReport">
                                        <label class="form-check-label" :for="`wip-report-${type}`">{{ type }}</label>
                                    </div>
                                </template>
                            </div>

                            <div class="mb-4">
                                <label class="form-label" for="dateUpTo">Up to and including date</label>
                                <input type="text" id="dateUpTo" class="form-control js-flatpickers" name="dateUpTo" v-model="dateUpTo" />
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-sm btn-success">Download</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from 'bootstrap/js/dist/modal';

export default {
    props: {
        onlyWip: {
            type: String,
        },
        reportRoutes: {
            type: Object,
        },
    },
    data() {
        return {
            currentReport: 'All',
            dateUpTo: null,
            modal: null,
        };
    },
    mounted() {
        this.modal = new Modal(this.$refs.modal);

        this.$refs.modal.addEventListener('hidden.bs.modal', () => {
            this.currentReport = 'All';
            this.dateUpTo = null;
        });

        if (document.location.hash == '#wip-report-pick-date') {
            this.modal.show();
        }
    },
};
</script>

<style scoped>
    .form-check {
        align-items: center;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding-left: 0;
    }
    .form-check .form-check-input {
        margin: 0 0 .5em;
    }
</style>
